export default [
  {
    path: "/ugg1RIKaeY",
    children: [
      {
        path: "XyGHA9k/:params?",
        name: "categories",
        meta: {
          title: "Categories",
          authRequired: true,
          acc: ["y73886"],
        },
        component: () => import("@/views/categories/index.vue"),
      },
      {
        path: "3xJ7gT2H2/:id?",
        name: "viewcategory",
        meta: {
          title: "View Category",
          authRequired: true,
          acc: ["y95833"],
        },
        component: () => import("@/views/categories/view.vue"),
      },
      // {
      //   // path: router.resolve({name: 'categories', params:{params: '034a948e37322172ae8a0821'} }),
      //   path: '034a948e37322172ae8a0821',
      //   name: "newcategory",
      //   meta: {
      //     title: "New Category",
      //     authRequired: true,
      //     acc: ["y11795"],
      //   },
      //   component: () => import("@/views/categories/index.vue"),
      // },
    ],
  },
];
